import React, { useRef } from "react";
import { Bar } from "react-chartjs-2";
import { Spin } from "antd";

const StoreWisePerformance = ({
  bucketLabels,
  selectedCycles,
  fontSize,
  onBarClick,
  stLoading,
}) => {
  const storeWiseChartRef = useRef(null);

  const maxStoreCount = Math.max(
    ...selectedCycles.flatMap((cycle) => cycle.counts || []),
    0,
  );
  
  const yAxisStep = Math.ceil(maxStoreCount * (1.1 / 5));
  const yAxisMax = yAxisStep * 5;

  return (
    <div className="upAuditsCard">
      <div className="upAuditsCard-header">
        <p className="heading">Store Wise Performance</p>
      </div>

      <div
        ref={storeWiseChartRef}
        className="chart-container p-3"
        style={{
          width: "100%",
          overflowX: window.innerWidth < 767 ? "auto" : "hidden",
          overflowY: "hidden",
          minWidth: window.innerWidth < 767 ? "600px" : "100%",
          height: "360px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {stLoading ? (
          <Spin size="medium" />
        ) : (
          <Bar
            data={{
              labels: bucketLabels,
              datasets: selectedCycles.map((cycle) => ({
                label: cycle.name,
                data: cycle.counts,
                backgroundColor: cycle.color,
                hoverBackgroundColor: cycle.barBorderColor,
                borderColor: cycle.barBorderColor,
                borderWidth: 1,
                borderRadius: 3,
                datalabels: {},
                barPercentage: 1,
              })),
            }}
            options={{
              responsive: true,
              maintainAspectRatio: false,
              devicePixelRatio: 2,
              onClick: (event, elements) => {
                if (!elements?.length) return;
                const { datasetIndex, index } = elements[0];
                const cycle = selectedCycles[datasetIndex];
                if (cycle) onBarClick?.(cycle, index);
              },
              onHover: (event, elements) => {
                event.native.target.style.cursor = elements?.length
                  ? "pointer"
                  : "default";
              },
              plugins: {
                legend: { display: false },
                datalabels: {
                  align: "end",
                  anchor: "end",
                  formatter: (value) => `${value}`,
                  color: (context) =>
                    selectedCycles[context.datasetIndex]?.barBorderColor ||
                    "#000",
                  font: { size: fontSize - 4, weight: "bold" },
                  offset: -2,
                  clip: false,
                },
              },
              scales: {
                y: {
                  beginAtZero: true,
                  max: yAxisMax,
                  ticks: {
                    stepSize: yAxisStep,
                    callback: (value) => `${value}`,
                    color: "#353E4C",
                    font: { family: "DM Sans" },
                  },
                  title: {
                    display: true,
                    text: "No. of Stores",
                    font: { size: 12, weight: "400" },
                    color: "#353E4C",
                  },
                  grid: { color: "#F1F2F4" },
                },
                x: {
                  title: {
                    display: true,
                    text: "Score Range (%)",
                    font: { size: 12, weight: "400", family: "DM Sans" },
                    color: "#353E4C",
                    padding: { top: 20 },
                  },
                  ticks: {
                    font: { size: 10, family: "DM Sans" },
                    color: "#353E4C",
                  },
                  grid: { display: false },
                  border: { display: true },
                },
              },
              layout: { padding: { right: 20 } },
            }}
          />
        )}
      </div>
    </div>
  );
};

export default StoreWisePerformance;
